import React from 'react'
import "./color.css"

function OrangeE() {
    var x = localStorage.getItem("percentage energy")

    return (
        <div className = "orange__background">
            {x == "NaN" ? "null": x} %
        </div>
    )
}

export default OrangeE
